@if (isVisible()) {
  <app-header-button
    label="Comunica"
    ariaLabel="Invia comunicazione all'organizzazione"
    [icon]="true"
    [disabled]="isSendingCommunication()"
    (clicked)="isCommunicationDialogOpen.set(true)"
    class="text-amber-600 dark:text-amber-400"
  >
    <svg icon class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
      />
    </svg>
  </app-header-button>
}

<app-validation-dialog
  [isOpen]="isValidationDialogOpen()"
  [violations]="validationErrors()"
  [tipoDocumento]="validationTipoDocumento()"
  [isLoading]="isSendingValidation()"
  (closeDialog)="isValidationDialogOpen.set(false)"
  (sendValidation)="onSendValidation($event)"
/>

<app-comparison-dialog
  [isOpen]="isComparisonDialogOpen()"
  [comparisons]="comparisonData()"
  [isLoading]="isComparing()"
  [viewMode]="comparisonViewMode()"
  [title]="comparisonTitle()"
  [description]="comparisonDescription()"
  (closeDialog)="isComparisonDialogOpen.set(false)"
/>

<app-notification-dialog
  [isOpen]="isCommunicationDialogOpen()"
  [isLoading]="isSendingCommunication()"
  title="Invia comunicazione"
  description="Invia un messaggio personalizzato a questa organizzazione."
  submitLabel="Invia messaggio"
  (closeDialog)="isCommunicationDialogOpen.set(false)"
  (submitForm)="sendCommunication($event)"
/>
